import { Injectable, inject, Signal } from '@angular/core';
import { Observable, filter, switchMap } from 'rxjs';
import { toSignal } from '@angular/core/rxjs-interop';
import { MpkFacade } from '@lentau/mpk/store';
import { MPKeys } from '@lentau/mpk/shared/constants';

@Injectable({
  providedIn: 'root',
})
export class MpkService {
  private mpkFacade: MpkFacade = inject(MpkFacade);

  // Новые значения МПК и его инициализации, которые используют кеш
  public isInit$: Observable<boolean> = this.mpkFacade.isInit$.pipe(filter(Boolean));
  public isInit: Signal<boolean | undefined> = toSignal(this.isInit$);
  public mpk: Signal<MPKeys> = this.mpkFacade.mpk;
  public mpk$: Observable<MPKeys> = this.mpkFacade.mpk$;
  // Отслеживание стартового значения и изменения значения МПК
  public mpkChanged$: Observable<MPKeys> = this.isInit$.pipe(switchMap((): Observable<MPKeys> => this.mpkFacade.mpk$));

  public switchOnMpkInit(source: Observable<unknown>): Observable<unknown> {
    return this.isInit$.pipe(switchMap(() => source));
  }
}
